module.exports = __webpack_public_path__ + "img/desjoyaux.af89cd91.jpg";